import { ImageUploaderTemplate } from "./template";
import { useImageUploader } from "./logic";

export const ImageUploader = ({ onLogoChange }: { onLogoChange?: (logo: string) => void } = {}): JSX.Element => {
  const props = useImageUploader(onLogoChange);
  return <ImageUploaderTemplate {...props} />;
};
